module.exports = __webpack_public_path__ + "img/tree-03-d-trunk.6384fee0.png";